import * as sentry from "@sentry/react";

const trackTiktokAnalytics = (
  eventName: string,
  data: Record<string, unknown> = {},
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).ttq?.track === "function"
    ) {
      (window as any).ttq.track(eventName, data);
    } else {
      console.warn(`TikTok is not available. Event: ${eventName}`);
    }
  } catch (e) {
    console.error(`Error in trackTiktokAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export const tiktokCompleteRegistration = () => {
  trackTiktokAnalytics("CompleteRegistration");
};

export default trackTiktokAnalytics;
